import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-double-chevron-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3327 17.3333L7.04573 12.9427C6.53945 12.4242 6.53945 11.5757 7.04573 11.0572L11.3327 6.66663"
        stroke="#6B7280"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M17.3327 17.3333L13.0457 12.9427C12.5394 12.4242 12.5394 11.5757 13.0457 11.0572L17.3327 6.66663"
        stroke="#6B7280"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class DoubleChevronIconComponent {
  width = input<string>('24');
  height = input<string>('24');
}
